var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3e8635",
    d: "M3.896 6.492L5.87 8.468l4.234-4.234a.45.45 0 0 1 .324-.141.45.45 0 0 1 .325.14l.621.65c.094.075.141.18.141.31a.38.38 0 0 1-.141.311l-5.193 5.193a.378.378 0 0 1-.311.142.375.375 0 0 1-.31-.142L2.625 7.762a.38.38 0 0 1-.141-.31c0-.131.047-.236.141-.31l.62-.65a.45.45 0 0 1 .326-.14.45.45 0 0 1 .325.14zm6.604 6.562a7.1 7.1 0 0 0 2.554-2.554A6.812 6.812 0 0 0 14 7a6.812 6.812 0 0 0-.946-3.5A7.1 7.1 0 0 0 10.5.946 6.812 6.812 0 0 0 7 0a6.812 6.812 0 0 0-3.5.946A7.1 7.1 0 0 0 .946 3.5 6.812 6.812 0 0 0 0 7c0 1.255.318 2.433.946 3.5A7.1 7.1 0 0 0 3.5 13.054 6.812 6.812 0 0 0 7 14a6.812 6.812 0 0 0 3.5-.946z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon_done.8f42aafb.svg";
export { ForwardRef as ReactComponent };